import * as React from "react";
const VoiceIcon = (props) => (
  <svg
    width="26px"
    height="26px"
    viewBox="0 0 1024 1024"
    className="icon"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M512.004 800.764c-171.261 0-312.303-137.185-314.403-305.805l-0.022-4.163c0-12.374 10.026-22.4 22.4-22.4 12.374 0 22.4 10.026 22.4 22.4l0.022 3.61c1.793 144.222 122.74 261.559 269.603 261.559 156.421 0 267.276-96.235 269.574-234.033 0.028-2.728 0.043-55.942 0.043-57.532 0-12.374 10.026-22.4 22.4-22.4s22.4 10.026 22.4 22.4c0 1.626-0.015 56.62-0.043 58.297-2.691 161.116-134.903 278.067-314.374 278.067z"
      fill="#152B3C"
    />
    <path
      d="M512.004 938.672c-12.374 0-22.4-10.026-22.4-22.4v-120.59c0-12.374 10.026-22.4 22.4-22.4 12.374 0 22.4 10.026 22.4 22.4v120.59c0 12.374-10.026 22.4-22.4 22.4z"
      fill="#152B3C"
    />
    <path
      d="M579.583 960H444.417c-12.374 0-22.4-10.026-22.4-22.4 0-12.374 10.026-22.4 22.4-22.4h135.166c12.374 0 22.4 10.026 22.4 22.4 0 12.374-10.026 22.4-22.4 22.4z"
      fill="#152B3C"
    />
    <path
      d="M695.905 512.684c0 99.915-82.337 180.91-183.904 180.91-101.568 0-183.904-80.996-183.904-180.91V244.91c0-99.915 82.337-180.91 183.904-180.91s183.904 80.995 183.904 180.91v267.774z"
      fill="#2577FF"
    />
    <path
      d="M682.564 306.658h-82.075c-8.247 0-14.933-6.686-14.933-14.933 0-8.246 6.686-14.934 14.933-14.934h82.075c8.246 0 14.934 6.687 14.934 14.934-0.001 8.247-6.688 14.933-14.934 14.933zM682.564 393.728h-82.075c-8.247 0-14.933-6.687-14.933-14.933 0-8.248 6.686-14.933 14.933-14.933h82.075c8.246 0 14.934 6.686 14.934 14.933-0.001 8.246-6.688 14.933-14.934 14.933zM682.564 479.332h-82.075c-8.247 0-14.933-6.686-14.933-14.933 0-8.246 6.686-14.933 14.933-14.933h82.075c8.246 0 14.934 6.687 14.934 14.933-0.001 8.248-6.688 14.933-14.934 14.933zM434.792 307.388h-82.075c-8.248 0-14.934-6.687-14.934-14.934s6.686-14.933 14.934-14.933h82.075c8.246 0 14.933 6.686 14.933 14.933 0.001 8.247-6.686 14.934-14.933 14.934zM434.792 394.464h-82.075c-8.248 0-14.934-6.686-14.934-14.933 0-8.246 6.686-14.933 14.934-14.933h82.075c8.246 0 14.933 6.687 14.933 14.933 0.001 8.248-6.686 14.933-14.933 14.933zM434.792 480.069h-82.075c-8.248 0-14.934-6.686-14.934-14.933 0-8.246 6.686-14.933 14.934-14.933h82.075c8.246 0 14.933 6.687 14.933 14.933 0.001 8.247-6.686 14.933-14.933 14.933z"
      fill=""
    />
  </svg>
);
export default VoiceIcon;
